<template>
  <div class="domain-search" :class="{ 'is-fixed': isFixed }">
    <div class="container clearfix">
      <div class="search clearfix">
        <div class="top clearfix">
          <span class="fl f16" v-if="layout.indexOf('ad1') !== -1"
            >企业经营互联网，第一步从域名开始</span
          >
          <span class="fr f12" v-if="layout.indexOf('ad2') !== -1"
            >新用户福利:注册领取789元大礼包，.com25元/首年，.xyz0元/首年</span
          >
        </div>
        <div class="domain-name-wrap fl f12">
          <input
            type="text"
            v-model="domainName"
            placeholder="请输入要查询的域名前缀..."
            @keydown.enter="query"
          />
          <div v-if="topRio == 'jztj'" class="domainName-tip">
            建站推荐域名含 .com、.cn、.net 三款后缀
          </div>
          <div v-if="topRio == 'ppbh'" class="domainName-tip">
            品牌保护推荐含 .网址、.中国、.企业 三款后缀
          </div>
          <div v-if="subRio == 'rmds'" class="domainName-tip">
            电商企业专属含 .公司、.网店、.网络 三款后缀
          </div>
        </div>
        <div class="domain-name-btns fl fix f12">
          <input
            type="radio"
            class="topRio-inp"
            id="jztj"
            value="jztj"
            name="topRio"
            @change="chooseTopRio"
            v-model="topRio"
          />
          <label class="topRio-label" for="jztj">建站推荐后缀</label>
          <input
            type="radio"
            class="topRio-inp"
            value="ppbh"
            id="ppbh"
            @change="chooseTopRio"
            name="topRio"
            v-model="topRio"
          />
          <label class="topRio-label" for="ppbh">品牌保护推荐</label>
          <input
            type="checkbox"
            class="topRio-inp spec"
            :class="{ moreBtnChecked: moreBtnChecked }"
            value="more"
            id="more"
            name="topRio"
            v-model="topRioMore"
          />
          <label class="topRio-label" @click="showPanel" for="more"
            >{{ topRioName }}
            <div v-if="!showMorePanel" class="el-icon-arrow-down"></div>
            <div v-else class="el-icon-arrow-up"></div>
          </label>

          <!-- <el-radio-group v-model="topRio"
                          @change="showPanel">
            <el-radio-button class="quick-query-btn"
                             label="jztj">建站推荐后缀</el-radio-button>
            <el-radio-button class="quick-query-btn"
                             label="ppbh">品牌保护推荐</el-radio-button>
            <el-radio-button class="quick-query-btn"
                             label="more">{{topRioName}}</el-radio-button>
          </el-radio-group> -->
        </div>
        <input type="button" value="查询" class="query-button" @click="query" />
        <div class="more-panel f12" v-if="showMorePanel">
          <div class="more-panel-line1 fix">
            <el-radio-group v-model="subRio" @change="chageSubRio" size="small">
              <el-radio-button class="quick-query-btn" label="jztj"
                >建站推荐后缀</el-radio-button
              >
              <el-radio-button class="quick-query-btn" label="ppbh"
                >品牌保护推荐</el-radio-button
              >
              <el-radio-button class="quick-query-btn" label="rmds"
                >热门电商域名</el-radio-button
              >
              <el-radio-button class="quick-query-btn" label="zxhz"
                >自选后缀 {{ "(" + totalSuffix + ")" }}</el-radio-button
              >
            </el-radio-group>
            <a
              v-if="subRio == 'zxhz'"
              class="choose-suffix-btn fr f12"
              @click="chooseSuffix"
              >确定</a
            >
          </div>
          <div v-if="showZXHZPanel" class="more-panel-line2">
            <div class="pColor f12 mb10 mt20">选择您要查询的域名后缀：</div>
            <div>
              <el-checkbox-group v-model="checkedSuffix">
                <div
                  v-for="(item, i) in suffix1"
                  style="width: 100px;"
                  :key="i"
                  class="dib mr10 mb10"
                >
                  <el-checkbox :label="item" :value="item">
                    <span class="sale-text">{{ item }}</span>
                  </el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
            <!-- <div class="pColor f12 mb10 mt20">更多行政区域后缀可选：</div>
            <div>
              <el-checkbox-group v-model="checkedArea">
                <div v-for="(item,i) in suffix3"
                     style="width: 100px;"
                     :key="i"
                     class="dib mr10 mb10">
                  <el-checkbox :label="item"
                               :value="item">
                    <span class="sale-text">{{item}}</span>
                  </el-checkbox>
                </div>
              </el-checkbox-group>
            </div> -->
          </div>
        </div>
        <!-- <div class="bottom clearfix"
             v-if="layout.indexOf('ad3')!==-1">
          <a :href="`/domain/info-intro/en/${item.name}`"
             target="_blank"
             v-for="item in suffixADList"
             class="price">.{{item.name}}
            <em>¥{{item.price}}</em>
          </a>
        </div> -->
        <div class="func-links fix f12" v-if="layout.indexOf('ad4') !== -1">
          <!-- <a class="fr mt10" target="_blank" href="/domain/price-table"
            >域名价格总览
          </a>
          <span class="fr mt10">&nbsp;|&nbsp;</span> -->
          <a class="fr mt10" target="_blank" href="/domain/home"
            >企业服务套餐
          </a>
          <span class="fr mt10">&nbsp;|&nbsp;</span>
          <a
            class="fr mt10"
            target="_blank"
            href="/domain/app-detail/domain-server-whoisbaohu"
            >域名隐私保护
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import suffix1 from "../../static/assets/suffix1";
import suffix2 from "../../static/assets/suffix2";
import suffix3 from "../../static/assets/suffix3";
import prohibitionsWordList from "../../static/assets/prohibitionsWordList";
export default {
  props: {
    layout: {
      default: ["ad3", "ad4"]
    },
    isFixed: {
      default: false
    }
  },
  data() {
    return {
      suffixADList: [
        {
          name: "top",
          price: "29"
        },
        {
          name: "vip",
          price: "36"
        },
        {
          name: "site",
          price: "40"
        },
        {
          name: "gold",
          price: "40"
        },
        {
          name: "online",
          price: "49"
        }
      ],
      topRio: "jztj",
      topRioMore: false,
      topRioName: "更多",
      subRio: "",
      checkedSuffix: [],
      checkedArea: [],
      suffixList: [...suffix1, ...suffix2],
      suffix1: suffix1,
      suffix2: suffix2,
      suffix3: suffix3,
      aeraList: [],
      domainName: this.$route.query.domainName,
      domainSuffix: "",
      showZXHZPanel: false,
      showMorePanel: false,
      moreBtnChecked: false,
      wordFlag: false
    };
  },
  computed: {
    language() {
      return /[\u4e00-\u9fa5]/g.test(this.domainName) ? "cn" : "en";
    },
    customSuffixes() {
      return [].concat(this.checkedSuffix, this.checkedArea);
    },
    totalSuffix() {
      return this.customSuffixes.length;
    }
  },
  watch: {
    // subRio: function (params) {
    //   this.checkedSuffix = []
    //   this.checkedArea = []
    //   if (params == 'zxhz') {
    //     this.topRioName = '自选后缀'
    //     this.showZXHZPanel = true
    //   } else if (params == 'rmds') {
    //     this.topRioName = '热门电商域名'
    //     this.showMorePanel = false
    //     this.showZXHZPanel = false
    //     // this.topRio = 'more'
    //   } else {
    //     this.showZXHZPanel = false
    //     this.topRio = params
    //     this.topRioName = '更多'
    //     this.showMorePanel = false
    //   }
    //   console.log(`subRio：${params}`)
    // }
  },
  methods: {
    chooseTopRio() {
      this.moreBtnChecked = false;
      this.subRio = this.topRio;
      this.topRioName = "更多";
    },
    chageSubRio(params) {
      this.checkedSuffix = [];
      this.checkedArea = [];
      if (params == "zxhz") {
        // this.topRioName = '自选后缀'
        this.showZXHZPanel = true;
        this.topRioMore = "more";
      } else if (params == "rmds") {
        this.topRioName = "热门电商域名";
        this.moreBtnChecked = true;
        this.showMorePanel = false;
        this.showZXHZPanel = false;
        this.topRioMore = true;
        this.topRio = "";
      } else {
        this.moreBtnChecked = false;
        this.topRioMore = "";
        this.showZXHZPanel = false;
        this.topRio = params;
        this.topRioName = "更多";
        this.showMorePanel = false;
      }
    },
    showPanel() {
      this.showMorePanel = !this.showMorePanel;
      // if (this.topRioMore) this.topRio = ''
      console.log(`点击更多，topRio：${this.topRio}`);
      console.log(`点击更多，subRio：${this.subRio}`);
      console.log(`点击更多，topRioMore：${this.topRioMore}`);
      if (this.topRio == "more") {
        this.showMorePanel = true;
      }

      if (this.topRio == "jztj" || this.topRio == "ppbh") {
        this.subRio = this.topRio;
      }
      console.log(`点击更多后，subRio：${this.subRio} `);
      // this.subRio = this.topRio
    },
    chooseSuffix() {
      console.log(this.customSuffixes);
      if (this.totalSuffix > 0) {
        this.topRioName = `自选后缀（${this.totalSuffix} ）`;
        this.moreBtnChecked = true;
        this.topRio = "";
      }
      this.showMorePanel = false;
    },
    hiddenMorePanel() {
      // this.subRio = ''

      this.showMorePanel = false;
      this.showZXHZPanel = false;
      this.showMorePanel = false;
    },
    checkQuickBtn_panel() {
      this.showZXHZPanel = false;
    },
    showZXHZ() {
      this.showZXHZPanel = true;
    },
    query() {
      this.wordFlag = false;
      const reg = new RegExp(
        "^[A-Za-z０１２３４５６７８９－0-9-Ａ-Ｚａ-ｚ\u4e00-\u9fa5]+$"
      );
      this.domainName = this.domainName.trim();
      // 如果不输入，不执行操作
      if (!this.domainName) return;

      // 完整域名拆分处理
      const index = this.domainName.indexOf(".");
      if (index !== -1) {
        this.domainName = this.domainName.substr(0, index);
      }
      // 违禁词
      prohibitionsWordList.map(v => {
        if (this.domainName.indexOf(v) !== -1) {
          this.wordFlag = true;
        }
      });
      if (this.wordFlag) {
        this.$msgbox({
          type: "error",
          message: "该域名限制注册！"
        });
        return;
      }
      if (this.domainName.length > 63) {
        this.$msgbox({
          type: "error",
          message: "域名长度超出最大限制！"
        });
        return;
      }
      if (this.domainName.length > 63) {
        this.$msgbox({
          type: "error",
          message: "域名长度超出最大限制！"
        });
        return;
      }

      if (!reg.test(this.domainName)) {
        if (this.language === "cn") {
          this.$msgbox({
            title: "您输入的域名不符合注册规则，请重新输入",
            type: "error",
            message:
              "提示：中文域名至少需要含有一个中文文字，可以包含中文、字母a-z(大小写等价)、数字0-9或者半角的连接符“-”，“-”不能放在开头或者结尾，输入内容不能超过63个字符，最多可以注册19个汉字。"
          });
        } else {
          this.$msgbox({
            title: "您输入的域名不符合注册规则，请重新输入",
            type: "error",
            message:
              "提示：域名可由英文字母（a-z,不区分大小写）、数字（0-9）、连字符“-”（即中横线）,不能使用空格及特殊字符（如！、$、&、？等），“-”不能单独填写或连续使用，不能放在开头或结尾，输入内容不能超过63个字符。"
          });
        }

        return;
      }
      // 解析后缀
      if (this.topRio == "jztj") {
        this.domainSuffix = ".com,.cn,.net";
      } else if (this.topRio == "ppbh") {
        this.domainSuffix = ".网址,.中国,.企业";
      } else if (this.subRio == "rmds") {
        this.domainSuffix = ".公司,.网店,.网络";
      } else if (this.subRio == "zxhz") {
        this.domainSuffix = this.customSuffixes.join();
      }
      this.$emit("query", {
        domainName: this.domainName.toLowerCase(),
        domainSuffix: this.domainSuffix
      });
    }
  }
};
</script>
<style scoped lang="scss">
@import "../../static/css/mixin.scss";
@import "../../static/css/new-domain-search.scss";
</style>
<style>
.domain-name-btns .el-radio-button__inner,
.more-panel el-radio-button--small .el-radio-button__inner {
  border-radius: 0px !important;
  width: 107px;
  height: 53px;
  padding: 0;
  line-height: 53px;
  cursor: pointer;
  color: #73777a;
  background: #fff;
}

.domain-name-btns .el-radio-button__inner:hover,
.more-panel .el-radio-button__inner:hover {
  color: #73777a;
}

.domain-name-btns
  .quick-query-btn
  .el-radio-button__orig-radio:checked
  + .el-radio-button__inner,
.more-panel
  .quick-query-btn
  .el-radio-button__orig-radio:checked
  + .el-radio-button__inner {
  color: #1fb09f;
  background-color: #e0eeed;
  border-color: #e0eeed;
  -webkit-box-shadow: -1px 0 0 0 #e0eeed;
  box-shadow: -1px 0 0 0 #e0eeed;
}

.domain-name-btns .el-radio-button__inner,
.more-panel .quick-query-btn .el-radio-button__inner {
  background-color: #ffffff;
}

.domain-name-btns
  .el-radio-button__orig-radio:checked
  + .el-radio-button__inner,
.more-panel .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #e0eeed;
  color: #1fb09f;
}
</style>



// WEBPACK FOOTER //
// src/components/new-domain-search.vue